export default "__VITE_ASSET__cf1c4dfc__"